import { dataLayerPush } from '@stelecom/ui-react/components/helpers';
import { ACTIONS, EVENTS, CATEGORIES } from '~/src/constants/analytics';

interface IData {
    action?: string,
    requestId: number | null,
    isPopup?: boolean,
    option?: string,
}

interface IFormat {
    requestId: number | null,
    isPopup?: boolean,
    action: string,
    option?: string,
}

/**
 * Возвращает свойство label в нужном формате с данными
 *
 * @function
 * @name helpers.getFormattedLabel
 * @param {number | null} requestId - id ответа запроса
 * @param {boolean} isPopup - место вызова
 * @param {string} action - тип действия события
 * @param {string} option - дополнительные свойства события как название акции/партнёрского сервиса/продукта и тд.
 * @returns {string | null}
 */
export const getFormattedLabel = ({ isPopup, requestId, option, action }: IFormat): string | null => {
    let id: null | string = '';
    let result = '';
    if (action === ACTIONS.finished) {
        id = (typeof requestId === 'number' || null) && String(requestId);
    }

    if (isPopup) {
        result = 'popup';
    }

    if (option) {
        result += `${isPopup ? ' | ' : ''}${option}`;
    }

    return result + `${result && id ? ` | ${id}` : id ? id : ''}`;
};

/**
 * Создает событие для аналитики типа UAevent - finished/error/started
 *
 * @function
 * @name helpers.dataLayerForCBPhonePush
 * @param {string} action - тип действия события
 * @param {number | null} requestId - id ответа запроса
 * @param {boolean} isPopup - место вызова
 * @param {string} option - дополнительные свойства события как название акции/партнёрского сервиса/продукта и тд.
 * @returns void
 */
export const dataLayerForCBPhonePush = ({ action = '', requestId = null, isPopup = false, option }: IData): void => {
    const actionWrap = action || (requestId ? ACTIONS.finished : ACTIONS.error);
    dataLayerPush({
        event: EVENTS.UAevent,
        category: CATEGORIES.applicationForm,
        action: actionWrap,
        label: getFormattedLabel({ isPopup, requestId, option, action: actionWrap }),
    });
};

/**
 * Отправляет событие VAS
 *
 * @function
 * @name helpers.sendVasGA
 * @param {string} action - дополнительный action
 * @param {string} label - label
 * @returns void
 */
export const sendVasGA = (action: string, label?: string): void => {
    dataLayerPush({
        event: EVENTS.UAevent,
        category: CATEGORIES.vas,
        action,
        label,
    });
};

/**
 * Создает функцию для отпрвки события с дополнительным label
 * example: 'partner services: '
 *
 * @function
 * @name helpers.createSendVasGA
 * @param {string} additionalLabel - дополнительный label
 * @returns void
 */
export const createSendVasGA = (additionalLabel: string) => (action: string, label?: string): void => {
    sendVasGA(action, label && `${additionalLabel} ${label}`);
};
